import { ApiMetadata } from '../types';
import Icon from '../../../components/AppIcon';

interface ApiMetadataPanelProps {
  metadata: ApiMetadata;
}

const ApiMetadataPanel = ({ metadata }: ApiMetadataPanelProps) => {
  return (
    <div className="bg-card rounded-lg border border-border p-6 space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold text-foreground">Metadados da API</h2>
        <span className={`px-3 py-1 rounded-full text-xs font-medium ${
          metadata.environment === 'production' ?'bg-success/10 text-success' :'bg-warning/10 text-warning'
        }`}>
          {metadata.environment === 'production' ? 'Produção' : 'Homologação'}
        </span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-4">
          <div>
            <label className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
              ID da Requisição
            </label>
            <p className="text-sm font-mono text-foreground mt-1 break-all">
              {metadata.requestId}
            </p>
          </div>

          <div>
            <label className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
              Timestamp
            </label>
            <p className="text-sm text-foreground mt-1">
              {metadata.timestamp.toLocaleString('pt-BR')}
            </p>
          </div>

          <div>
            <label className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
              Tempo de Resposta
            </label>
            <div className="flex items-center gap-2 mt-1">
              <Icon name="Clock" size={16} color="var(--color-primary)" />
              <p className="text-sm font-medium text-primary">
                {metadata.responseTime}ms
              </p>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <div>
            <label className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
              Versão da API
            </label>
            <p className="text-sm font-mono text-foreground mt-1">
              {metadata.apiVersion}
            </p>
          </div>

          <div>
            <label className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
              Token Utilizado
            </label>
            <p className="text-sm font-mono text-foreground mt-1 break-all">
              {metadata.tokenUsed.substring(0, 20)}...
            </p>
          </div>

          <div>
            <label className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
              Ambiente
            </label>
            <p className="text-sm text-foreground mt-1 capitalize">
              {metadata.environment === 'production' ? 'Produção' : 'Homologação'}
            </p>
          </div>
        </div>
      </div>

      <div className="pt-4 border-t border-border">
        <div className="flex items-start gap-3 p-4 bg-accent/5 border border-accent/20 rounded-md">
          <Icon name="Info" size={18} color="var(--color-accent)" className="mt-0.5 flex-shrink-0" />
          <div className="flex-1">
            <p className="text-sm text-foreground">
              Esta consulta foi processada através da API Gestor Tributário 3.0 SaneamentoGrades.
              Todos os dados são armazenados com rastreabilidade completa para fins de auditoria.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApiMetadataPanel;